<template>
  <v-container class="mt-5" grid-list-xl>

    <div v-if="showError" class="mt-5">
      <h2>Oj, bilden hittades inte!</h2>
      <a href="https://www.pretopia.se">Gå tillbaka till startsidan och gör en ny sökning</a>
    </div>

    <image-dialog-component 
        :visible="showImage"
        :persistent="true"
        :image="imageItem"
        @close="onDialogClose"></image-dialog-component>

  </v-container>
</template>

<script>
import { updateThumbnailPath } from '@shared/functions';
import ImageDialogComponent from '../../components/dialog/ImageDialogComponent.vue'
import { ImageService } from '../../services/image.service';

export default {
  components: {
      ImageDialogComponent
  },

  data() {
    return {
      imageService: new ImageService(),
      imageItem: { },
      allImagesItems: [],
      showImage: false,
      showError: false
    }
  },

  created() {
    window.scrollTo(0,0);
    const id = this.$route.params.id;

    this.imageService.getById(id)
      .then(image => {
        return updateThumbnailPath(image);
      })
      .then(item => this.imageItem = item)
      .then(() => this.showImage = true)
      .then(() => this.updateMetaInfo())
      .catch(() => this.showError = true);
  },

  methods: {

    onDialogClose() {
      this.$router.push('/');
    },

    updateMetaInfo() {
      const defaultDescription = 'Bildbank för dig som är frilansskribent eller arbetar på redaktion kan du här snabbt och enkelt söka efter bilder från leverantörer inom hem, inredning och trädgård.';
      const title = document.head.querySelector('title');
      const metaDescription = document.head.querySelector('meta[name=description]');
      const metaKeywords = document.head.querySelector('meta[name=keywords]');

      const tags = this.imageItem.tags.map(t => t.name).join(',');
      const titleContent = 'Bild från ' + this.imageItem.company.name + ' - Pretopia';

      if (!title) {
        const titleNode = document.createElement('title');
        titleNode.appendChild(document.createTextNode(titleContent));
        document.head.appendChild(titleNode);
      } else {
        title.innerText = titleContent;
      }

      if (!metaDescription) {
        document.head.appendChild(
          document.createElement('meta', { name: 'description', content: this.imageItem.description || defaultDescription })
        );
      } else {
        metaDescription.setAttribute('content', this.imageItem.description || defaultDescription);
      }

      if (!metaKeywords) {
        document.head.appendChild(
          document.createElement('meta', { name: 'keywords', content: tags || '' })
        );
      } else {
        metaKeywords.setAttribute('content', tags || '');
      }
    }
  }
}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
